const navData = [
    {
        name: 'About',
        link : '/about'
    },
    {
        name: 'Trips',
        link : '/trips'
    },
    {
        name: 'Flights',
        link : '/flights'
    },
    {
        name: 'Contact',
        link : '/contact'
    }
]
export default navData;